/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Edit_Contract_Description_LiveInputs */



/**
* | output |
* | --- |
* | "Changes apply to the running contract straight away and are recorded in the audit log. Seats, budget and length cannot go below what is already in use." |
*
* @param {Partner_Edit_Contract_Description_LiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_description_live = /** @type {((inputs?: Partner_Edit_Contract_Description_LiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_Description_LiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen gelten sofort für den laufenden Vertrag und werden im Audit-Log festgehalten. Plätze, Budget und Laufzeit können nicht unter das bereits Genutzte fallen.")
	return /** @type {LocalizedString} */ ("Changes apply to the running contract straight away and are recorded in the audit log. Seats, budget and length cannot go below what is already in use.")
});